import React, { useState } from 'react';
import { useTranslation } from '../i18n';
import closeButton from '../images/close-line-white.svg';
import calIcon from './../images/calendar-line.svg';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const ChangeWeekstart = () => {
  const { t, weekStart, changeWeekstart } = useTranslation();
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleUpdate = (val) => {
    changeWeekstart(val);
    logEvent(analytics, 'account_settings_weekstart', { weekstart: val });
    closeModal();
  };

  return [
    <div className="row-item" key="item-row">
      <img height={24} width={24} alt="Change language" src={calIcon} />
      <div
        className="link"
        onClick={openModal}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            openModal();
          }
        }}
        tabIndex={0}
      >
        {t.changestartweek}
      </div>
      <div className="pt-65 fs-s flex-grow align-right">
        {weekStart === 'sun' ? t.sun : t.mon}
      </div>
    </div>,
    modalIsOpen && (
      <div className="overlay" key="overlay">
        <div className="buttons-wrapper">
          <div className="buttons-header">
            <span>{t.changestartweek}</span>
            <button className="btn-icon" onClick={closeModal}>
              <img
                className="icon"
                src={closeButton}
                width={24}
                height={24}
                alt="Close icon"
              />
            </button>
          </div>
          <div className="separator"></div>
          <div className="buttons">
            <button
              className="btn btn-secondary"
              onClick={() => handleUpdate('mon')}
            >
              {t.monday}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleUpdate('sun')}
            >
              {t.sunday}
            </button>
          </div>
        </div>
      </div>
    ),
  ];
};

export default ChangeWeekstart;
